import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

export interface MeetingRequestDialogState {
	notificationId: string;
}

@Injectable()
export class MeetingRequestDialogStore extends Store<MeetingRequestDialogState> {
	constructor() {
		super({}, { name: `ui-meeting-request-dialog-${guid()}` });
	}
}
